import { Container } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { FormLayout, StepFormWizard } from "../../../Constant";
import { ToastContainer } from "react-toastify";
import CustomHorizontalWizard from "./CustomHorizontalWizard";
import BusinessVerticalWizard from "./BusinessVerticalWizard";

const FormWizardTwoContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={StepFormWizard} parent={FormLayout} title={StepFormWizard} />
      <Container fluid>
        <CustomHorizontalWizard heading="Custom horizontal wizard" xs={12} />
        <BusinessVerticalWizard heading="Business vertical wizard" firstXl={3} secondXl={9} horizontalWizardClass="vertical-options" />
        <CustomHorizontalWizard heading="Custom vertical wizard" horizontalWizardClass="vertical-options vertical-variations" firstXl={3} secondXl={9} />
        <BusinessVerticalWizard heading="Business horizontal wizard" xs={12} />
      </Container>
      <ToastContainer />
    </>
  );
};

export default FormWizardTwoContainer;
